import React, {Component} from 'react';
import {connect} from 'react-redux';
import LocaleStrings from '@language';
import BaseLoader from '@baseLoader';
import DashboardHead from './dashboardhead';
import Dashboardsubheader from './dashboardsubheader';
import DashboardBottom from './dashboardbottom';
import {fetchAppuser} from '@sidebarActions';
import {withCookies} from 'react-cookie';
import {sessionCookieName} from '../../../../common/constants';
import {getSocialLoginType} from '../../../../actions';

class DashboardMain extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isShowContactPopup: false,
      loaderDesc: LocaleStrings.preparing_dashboard,
    };

    // All Binded Functions
  }

  _handleContactUsPopup(createdon, credits) {
    const bus_email_credits = credits.bus_email_credits || 0;
    const personal_email_credits = credits.personal_email_credits || 0;
    const isAllCreditsZero =
      credits.contactcredit === 0 &&
      bus_email_credits === 0 &&
      personal_email_credits === 0;

    const targetDateObj = new Date('2025-07-10');
    targetDateObj.setHours(0, 0, 0, 0);

    const createdDateObj = new Date(createdon);
    createdDateObj.setHours(0, 0, 0, 0);

    const isSameOrAfter = createdDateObj.getTime() >= targetDateObj.getTime();

    if (isSameOrAfter && isAllCreditsZero) {
      this.setState({isShowContactPopup: true});
    }
  }

  componentDidMount() {
    let {session, user} = this.props;
    this.props.getSocialLoginType(session, {clientid: user.clientid});

    this.props.fetchAppuser(session, user.appuserid, response => {
      if (response?.success === 1 && response.data) {
        const createdon = response?.data?.resource[0]?.createdon;
        const credits =
          response?.data?.resource[0]?.client_by_clientid
            ?.usercredit_by_clientid[0];
        this._handleContactUsPopup(createdon, credits);
      }

      this.setState({loading: false});
    });

    const {cookies} = this.props;
    cookies.set(sessionCookieName, session.sessionToken);
  }

  render() {
    let {user} = this.props;

    return (
      <>
        {this.state.loading ? (
          <>
            <BaseLoader data={this.state.loaderDesc} />
          </>
        ) : (
          <div
            className="overflow-y-auto scrollbar-hide relative"
            style={{height: 'calc(100vh / var(--zoom) - 30px)'}}>
            {/* Divided the dashboard in the component */}
            <DashboardHead history={this.props.history} />
            <Dashboardsubheader history={this.props.history} />
            <DashboardBottom history={this.props.history} />

            {/* {this.state.isShowContactPopup && (
              <div className="absolute  inset-0  flex justify-center items-center ">
                <div className="relative bottom-28 h-96 w-1/2 border-2 shadow-md bg-white rounded-md flex flex-col gap-2 justify-center items-center">
                  <p className="text-xl mb-2 ">
                    Free credits are temporarily unavailable. Contact us to get
                    credits.
                  </p>
                  <div className="w-1/4">
                    <button className="btn-primary">
                      <a href="https://book.kipplo.com/" target="_blank">
                        Contact Us
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            )} */}
          </div>
        )}
      </>
    );
  }
}

var mapStateToProps = state => ({
  isLoggedIn: state.isLoggedIn,
  user: state.user,
  session: state.session,
});

export default connect(mapStateToProps, {
  fetchAppuser,
  getSocialLoginType,
})(withCookies(DashboardMain));
